import _extends from "@babel/runtime/helpers/extends";
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { defaultTo } from 'lodash-es';
import eventCode from '../utils/event-code';
import StyledLink from './styles';
const linkAsButton = ({
  href,
  onClick,
  role = 'button',
  tabIndex = 0,
  onKeyPress: originalKeyPress
}) => {
  if (href) return {
    tabIndex
  };
  const onKeyPress = event => {
    const code = eventCode(event);
    if (originalKeyPress) {
      originalKeyPress(event);
    }
    if ((code === 'Enter' || code === 'Space') && onClick) {
      onClick(event);
    }
  };
  return {
    role,
    tabIndex,
    onKeyPress,
    ...(onClick ? {
      onClick
    } : {})
  };
};
const Link = /*#__PURE__*/forwardRef(({
  type = 'default',
  children,
  anchorComponent = null,
  dashed = false,
  bold = false,
  inherit = false,
  openInNewWindow = false,
  reverseFocus = false,
  ...props
}, ref) => {
  const openInNewWindowProps = openInNewWindow ? {
    target: '_blank',
    rel: 'noopener noreferrer'
  } : {};
  const $props = {
    $reverseFocus: reverseFocus,
    $bold: bold
  };
  const interactiveProps = !props.href && !props.onClick ? {
    as: defaultTo(anchorComponent, 'span')
  } : linkAsButton(props);
  return /*#__PURE__*/React.createElement(StyledLink, _extends({
    "data-type": type,
    "data-dashed": dashed,
    "data-inherit": inherit,
    as: anchorComponent,
    ref
  }, openInNewWindowProps, $props, props, interactiveProps), children);
});
Link.propTypes = {
  anchorComponent: PropTypes.elementType,
  children: PropTypes.node,
  dashed: PropTypes.bool,
  bold: PropTypes.bool,
  inherit: PropTypes.bool,
  openInNewWindow: PropTypes.bool,
  type: PropTypes.oneOf(['default', 'unstyled', 'text', 'no-underline']),
  reverseFocus: PropTypes.bool
};
export default Link;
export { linkAsButton };
//# sourceMappingURL=index.js.map